import NewsletterBar from "../components/NewsletterBar";
import "./NewsletterSignupPage.css";

export default function NewsletterSignupPage() {
  return (
    <div className="newsletter-signup-page-container">
      <NewsletterBar />
    </div>
  );
} 